"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Transfer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Transfer = function Transfer(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.824 8.121L13.41 6.066a.25.25 0 00-.412.19v1.246h-3c-1.654 0-3 1.346-3 3v4.5a1 1 0 002 0v-4.5c0-.552.449-1 1-1h3v1.245c0 .213.25.329.412.19l2.414-2.054a.5.5 0 000-.762zm-9.826-.619h-3v-1.2a.25.25 0 00-.41-.192L.18 8.117a.5.5 0 000 .768l2.407 2.008a.25.25 0 00.411-.192v-1.2h3c.044 0 .086.007.128.013a3.99 3.99 0 011-1.791 2.983 2.983 0 00-1.128-.222zM5.562 2.59L7.617.175a.5.5 0 01.762 0l2.055 2.413a.25.25 0 01-.191.413H8.998v3.631a3.96 3.96 0 00-.992.415 3.954 3.954 0 00-1.008-.415v-3.63H5.753a.25.25 0 01-.19-.412z",
    fill: "currentColor"
  }));
};

exports.Transfer = Transfer;
var _default = Transfer;
exports.default = _default;